export default "__VITE_ASSET__BsbkBSMf__"